const generateFormLeaveType = [
  {
    label: "ชื่อรูปแบบ",
    name: "leave_type_name",
    placeholder: "ป้อนชื่อรูปแบบ",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "กรุณาป้อนชื่อรูปแบบ",
    disable: false,
    section: "information",
  },
  {
    label: "ผู้ตรวจสอบคำร้องขอลา",
    name: "auditor_empmloyee_id",
    placeholder: "ป้อนผู้ตรวจสอบคำร้องขอลา",
    type: "autocomplete",
    typeForm: "text",
    formSize: "small",
    optionName: "employee",
    defaultOption: "id_employee",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนผู้ตรวจสอบคำร้องขอลา",
    disable: false,
    section: "information",
  },
  {
    label: "ตำแหน่งงาน",
    name: "auditor_empmloyee_position",
    placeholder: "ป้อนตำแหน่งงาน",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนตำแหน่งงาน",
    disable: true,
    section: "information",
  },
  {
    label: "ผู้อนุมัติคำร้องขอลา",
    name: "approve_empmloyee_id",
    placeholder: "ป้อนผู้อนุมัติคำร้องขอลา",
    type: "autocomplete",
    typeForm: "text",
    formSize: "small",
    optionName: "employee",
    defaultOption: "id_employee",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนผู้อนุมัติคำร้องขอลา",
    disable: false,
    section: "information",
  },
  {
    label: "ตำแหน่งงาน",
    name: "approve_empmloyee_position",
    placeholder: "ป้อนตำแหน่งงาน",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนตำแหน่งงาน",
    disable: true,
    section: "information",
  },
  {
    label: "รูปแบบฟอร์ม",
    name: "leave_type_form_template",
    placeholder: "ป้อนรูปแบบฟอร์ม",
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_form",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "กรุณาป้อนรูปแบบฟอร์ม",
    disable: false,
    section: "information",
  },
  {
    label: "หมวดหมู่การลา",
    name: "category",
    placeholder: "เลือกหมวดหมู่การลา",
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type_category",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "กรุณาเลือกหมวดหมู่การลา",
    disable: false,
    section: "information",
    // แสดง field นี้เฉพาะเมื่อรูปแบบฟอร์มที่เลือกมีคำว่า "อาพาธ" (คือ "ใบลาอาพาธ/ป่วย ลากิจ ลาคลอดบุตร")
    visibleWhenLeaveFormIncludes: "อาพาธ",
  },
  {
    label: "การสะสมวันลาข้ามปี",
    name: "leave_days_across_years",
    placeholder: "ป้อนการสะสมวันลาข้ามปี",
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "status",
    defaultOption: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "กรุณาป้อนการสะสมวันลาข้ามปี",
    disable: false,
    section: "information",
  },
];

export default generateFormLeaveType;
